import styles from "./Contact.module.css";
import { Header } from "../../elements/header/Header";

export default function Contact() {
    return <>
        <Header/>
        <div className={styles.pageContent}>
            <h1>Работники сервиса:</h1>
            <p><strong>Андрей Данилюк</strong>:<br/>Веб-приложение, база данных, владелец сервиса</p>
            <div className={styles.ContactsList}>
                <ContactType
                    img={"/images/white/contact/telegram.png"}
                    name={"Telegram"} subname={"@andrey_daniluk"}
                    onClick={() => {window.open("https://t.me/andrey_daniluk")}}
                />
                <ContactType
                    img={"/images/white/contact/post.png"}
                    name={"E-Mail"} subname={"andrey@danyliuk.ch"}
                    onClick={() => {window.location = "mailto:andrey@danyliuk.ch"}}
                />
            </div>
            <p><strong>Андрей Лентяй</strong>:<br/>API сервер, база данных</p>
            <div className={styles.ContactsList}>
                <ContactType
                    img={"/images/white/contact/telegram.png"}
                    name={"Telegram"} subname={"@AndrewLentay"}
                    onClick={() => {window.open("https://t.me/AndrewLentay")}}
                />
            </div>
        </div>
    </>
}


function ContactType({img, name, subname, onClick}) {
    return <div className={styles.contactCard} onClick={onClick}>
        <img src={img} alt={name}/>
        <div className={styles.contactCardText}>
            <h3>{name}</h3>
            <h4>{subname}</h4>
        </div>
    </div>
}